import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map, shareReplay, startWith, switchMap, take } from 'rxjs/operators';
import { ShopService } from '@app/core/services/models/shops.service';

export type ShopLike = { id: number; name?: any } & Record<string, any>;

function normalizeShopList(list: unknown): ShopLike[] {
  if (Array.isArray(list)) return list as ShopLike[];
  if (list && typeof list === 'object' && 'data' in (list as any) && Array.isArray((list as any).data)) {
    return (list as any).data as ShopLike[];
  }
  return [];
}

@Injectable({ providedIn: 'root' })
export class ShopsStore {
  private readonly refresh$ = new Subject<void>();

  /** Cache global des shops: 1 seul fetch au 1er subscribe, puis replay. */
  readonly shops$: Observable<ShopLike[]> = this.refresh$.pipe(
    startWith(void 0),
    switchMap(() =>
      this.shopService.all({ skipLoader: true }).pipe(
        map((res: unknown) => normalizeShopList(res)),
        catchError(() => of([] as ShopLike[]))
      )
    ),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  constructor(private shopService: ShopService) {}

  /** Force une récupération depuis l'API (ex. après ajout d'un shop). */
  refresh(): void {
    this.refresh$.next();
  }

  /** Déclenche le 1er chargement (utilisé au boot). */
  loadOnce(): Observable<ShopLike[]> {
    return this.shops$.pipe(take(1));
  }
}

